<script setup lang="ts">
// See vite.config.ts for details about automatic imports
const route = useRoute()
const store = useStore();

// Ensure the store is initialized
if (!store.isInitialized) {
  store.initApp();
}

useHead({
  title: () => route.meta.title || 'Swish - Astrological Commentary',
  meta: [
    {
      property: 'og:title',
      content: () => route.meta.title,
    },
    {
      name: 'twitter:title',
      content: () => route.meta.title,
    },
  ],
})

// const VERSION = import.meta.env.VITE_APP_VERSION
// const BUILD_DATE = import.meta.env.VITE_APP_BUILD_EPOCH
//   ? new Date(Number(import.meta.env.VITE_APP_BUILD_EPOCH))
//   : undefined
// const thisYear = new Date().getFullYear()
</script>

<template>
  <div class="flex flex-col min-h-screen text-white">
    <Background />
    <!-- Navigation -->
    <Navigation />

    <!-- Content -->
    <div class="flex-grow">
      <router-view></router-view>
    </div>
  </div>
</template>
